document.addEventListener('DOMContentLoaded', function() {
    setTimeout(function() {
        const headerContainer = document.querySelector('.sf-header');
        if (!headerContainer) return;

        function resetDropdownScrollPositions() {
            // Reset desktop dropdown menus
            const dropdownMenus = headerContainer.querySelectorAll('.sf-menu-submenu__items');
            dropdownMenus.forEach(menu => {
                if (menu.scrollTop > 0) {
                    menu.scrollTop = 0;
                }
            });
        }

        function resetMobileMenuScrollPosition() {
            // Reset main mobile menu content scroll
            const mobileMenuContent = document.querySelector('.sf-menu-wrapper-mobile .sf-menu__content');
            if (mobileMenuContent && mobileMenuContent.scrollTop > 0) {
                mobileMenuContent.scrollTop = 0;
            }
            
            // Reset menu links container scroll
            const mobileMenuLinks = document.querySelector('.sf-menu-wrapper-mobile .sf-menu-links');
            if (mobileMenuLinks && mobileMenuLinks.scrollTop > 0) {
                mobileMenuLinks.scrollTop = 0;
            }
            
            // Reset submenu scroll areas (the ones with overflow-y-scroll)
            const submenuScrollAreas = document.querySelectorAll('.sf-menu-wrapper-mobile .sf-sub-links .overflow-y-scroll');
            submenuScrollAreas.forEach(area => {
                if (area.scrollTop > 0) {
                    area.scrollTop = 0;
                }
            });
            
            // Reset any other scrollable containers in mobile menu
            const allScrollableContainers = document.querySelectorAll('.sf-menu-wrapper-mobile [class*="overflow-y-scroll"], .sf-menu-wrapper-mobile .sf-sub-links > div');
            allScrollableContainers.forEach(container => {
                if (container.scrollTop > 0) {
                    container.scrollTop = 0;
                }
            });
        }

        // Desktop functionality
        const originalSiteNav = window.siteNav_MinimogTheme?.siteNav;
        if (originalSiteNav && originalSiteNav.resetMegaMenu) {
            const originalResetMegaMenu = originalSiteNav.resetMegaMenu;
            originalSiteNav.resetMegaMenu = function() {
                originalResetMegaMenu.call(this);
                resetDropdownScrollPositions();
            };
        }

        // Hook into the mobile menu close functionality by overriding the closeMenu method
        // Wait for MobileNav to be initialized
        setTimeout(function() {
            if (window.MinimogTheme && window.MinimogTheme.MobileNav) {
                const mobileNav = window.MinimogTheme.MobileNav;
                if (mobileNav.closeMenu) {
                    const originalCloseMenu = mobileNav.closeMenu.bind(mobileNav);
                    mobileNav.closeMenu = function() {
                        // Call the original close menu function
                        originalCloseMenu();
                        // Reset scroll position after menu is closed
                        setTimeout(resetMobileMenuScrollPosition, 50);
                    };
                }
            }
        }, 1000);

        // Fallback: Watch for mobile menu wrapper changes
        const mobileMenuWrapper = document.querySelector('.sf-menu-wrapper-mobile');
        if (mobileMenuWrapper) {
            // Watch for class changes on mobile menu wrapper
            const mobileObserver = new MutationObserver(function(mutations) {
                mutations.forEach(function(mutation) {
                    if (mutation.type === 'attributes' && 
                        mutation.attributeName === 'class') {
                        
                        // Check if mobile menu was closed (hidden class added)
                        if (mutation.target.classList.contains('hidden')) {
                            setTimeout(resetMobileMenuScrollPosition, 50);
                        }
                    }
                });
            });

            mobileObserver.observe(mobileMenuWrapper, { 
                attributes: true, 
                attributeFilter: ['class'] 
            });

            // Watch for transform changes on mobile menu content
            const mobileMenuContent = document.querySelector('.sf-menu-wrapper-mobile .sf-menu__content');
            if (mobileMenuContent) {
                const contentObserver = new MutationObserver(function(mutations) {
                    mutations.forEach(function(mutation) {
                        if (mutation.type === 'attributes' && 
                            mutation.attributeName === 'class') {
                            
                            // Check if mobile menu content was translated out (closed)
                            if (mutation.target.classList.contains('-translate-x-full')) {
                                setTimeout(resetMobileMenuScrollPosition, 50);
                            }
                        }
                    });
                });

                contentObserver.observe(mobileMenuContent, { 
                    attributes: true, 
                    attributeFilter: ['class'] 
                });
            }

            // Event-based mobile menu close detection
            mobileMenuWrapper.addEventListener('click', function(e) {
                if (e.target === mobileMenuWrapper) {
                    setTimeout(resetMobileMenuScrollPosition, 50);
                }
            });
        }

        // Desktop menu functionality
        const observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
                if (mutation.type === 'attributes' && 
                    mutation.attributeName === 'class' && 
                    mutation.target.classList.contains('sf-header')) {
                    
                    if (!mutation.target.classList.contains('sf-mega-active')) {
                        resetDropdownScrollPositions();
                    }
                }
            });
        });

        observer.observe(headerContainer, { 
            attributes: true, 
            attributeFilter: ['class'] 
        });

        const menuItems = headerContainer.querySelectorAll('.sf-menu-item');
        menuItems.forEach(menuItem => {
            menuItem.addEventListener('mouseleave', function() {
                setTimeout(resetDropdownScrollPositions, 100);
            });
        });

        // Listen for escape key to close mobile menu
        document.addEventListener('keydown', function(e) {
            if (e.key === 'Escape' && mobileMenuWrapper && !mobileMenuWrapper.classList.contains('hidden')) {
                setTimeout(resetMobileMenuScrollPosition, 350);
            }
        });

    }, 500);
});
